export { default as IllustrationLogin } from './illustration-login.svg';
export { default as Illustration404 } from './illustration-404.svg';
export { default as IllustrationRegister } from './illustration-register.svg';
export { default as IllustrationSuccess } from './illustration-success.svg';
export { default as IllustrationLanding } from './illustration-landing.svg';
export { default as IllustrationNotFound } from './illustration-not-found.svg';
export { default as IllustrationRewardNotFound } from './illustration-reward-not-found.svg';
export { default as IllustrationVoucherClaimed } from './illustration-voucher-claimed.svg';
export { default as IllustrationOtp } from './illustration-otp.svg';
export { default as IllustrationOtpBig } from './illustration-otp-big.svg';
